import { createEdit, COPY, DELETE } from '@/helpers/enums/table-actions'
import { GROUPS_ROUTES as ROUTES } from './utils'
import { dateFormatter } from '@/helpers/dateFormatter'


const getEditRoute = (data) => ({
  name: ROUTES.EDIT,
  params: { id: data.id },
})

export const TABLE_ACTIONS = Object.freeze([
  createEdit(getEditRoute),
  COPY,
  DELETE,
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'Название',
    value: 'name',
    sortable: false,
    getRoute: (data) => ({
      name: ROUTES.VIEW,
      params: { id: data.id },
    }),
  },
  {
    text: 'Дата создания',
    value: 'created_at',
    sortable: true,
    width: 140,
    field: (value) => value && dateFormatter(value),
  },
  {
    text: 'Дата обновления',
    value: 'updated_at',
    sortable: true,
    width: 152,
    field: (value) => value && dateFormatter(value),
  },
  {
    text: 'Права',
    value: 'permissions',
    sortable: false,
  },
  {
    text: 'ATE',
    value: 'ates',
    sortable: false,
  },
])
